import{a as m}from"./chunk-6RILKS4L.js";import{f as o,v as r}from"./chunk-QER6B7LL.js";import{m as a}from"./chunk-HBP5N4FR.js";a();r();var g=t=>({egldValueData:{value:t,formattedValue:m({input:t}),decimals:o}});export{g as a};
//# sourceMappingURL=chunk-NF37CUPZ.js.map
